import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import EditIcon from '../../assets/EditIcon'
import EditIconActive from '../../assets/EditIconActive'
import {
    HEADER_CONFIG,
    HEADER_CONST
} from '../../common/constant/common-constant'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import { convertToTitleCase } from '../../common/utils/appUtils'
import {
    getPersonalDetailsHelper,
    updatePasswordHelper,
    updatePersonalDetailsHelper
} from '../../helper/personal-details-helper'
import {
    sendOTPHelper,
    validateOTPHelper
} from '../../helper/create-account-helper'
import MobileHeader from '../Common/Header/MobileHeader'
import Config from '../../config/config'

import './PersonalDetails.scss'
import AttachIcon from '../../assets/AttachIcon'
import CheckIcon from '../../assets/CheckIcon'
import CloseIcon from '../../assets/CloseIcon'
import LocationIcon from '../../assets/LocationIcon'
import CustomMap from '../../components/CustomMap/CustomMap'

const OTP_STAGE = {
    SEND_OTP: 'SEND_OTP',
    VERIFY_OTP: 'VERIFY_OTP'
}

const PersonalDetails = props => {
    const isMobile = useCheckMobileScreen()

    const [data, setData] = useState(undefined)
    const [headerOptions, setHeaderOptions] = useState({
        [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
        [HEADER_CONFIG.TITLE]: HEADER_CONST.PERSONAL_DETAILS,
        [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => props?.onBackClick()
    })
    const [isEditActive, setIsEditActive] = useState(false)
    const [isEditing, setIsEditing] = useState(false)
    const [profileImageFile, setProfileImageFile] = useState(undefined)
    const [pharmacyLogo, setPharmacyLogo] = useState(undefined)
    const [errMsg, setErrMsg] = useState(undefined)
    const [startTime, setStartTime] = useState({
        hours: 0,
        minutes: 0
    })
    const [closeTime, setCloseTime] = useState({
        hours: 0,
        minutes: 0
    })
    const [timePopup, setTimePopup] = useState('')
    const [editingPassword, setEditingPassword] = useState(false)

    const [currentPassword, setCurrentPassword] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')

    const [editableLocation, setEditableLocation] = useState('')
    const [editableOwnerName, setEditableOwnerName] = useState('')
    const [editablePhoneNumber, setEditablePhoneNumber] = useState('')
    const [editableEmail, setEditableEmail] = useState('')
    const [isOwnerDetailsEditActive, setIsOwnerDetailsEditActive] = useState(false)
    
    // Google Map states
    const [showMap, setShowMap] = useState(false)
    const [latitude, setLatitude] = useState(undefined)
    const [longitude, setLongitude] = useState(undefined)
    const [placeId, setPlaceId] = useState(undefined)
    const [addressComponent, setAddressComponent] = useState(undefined)

    // OTP states for phone number verification
    const [showOtpModal, setShowOtpModal] = useState(false)
    const [otpStage, setOtpStage] = useState(OTP_STAGE.SEND_OTP)
    const [otp, setOtp] = useState(['', '', '', ''])
    const [newPhoneNumber, setNewPhoneNumber] = useState('')
    const [otpError, setOtpError] = useState('')
    const otpInputs = useRef([])

    useEffect(() => {
        getPersonalDetails()
    }, [])

    const getPersonalDetails = () => {
        getPersonalDetailsHelper()
            .then(res => {
                setData(res)
                setStartTime({
                    hours: res?.start_time?.split(':')[0],
                    minutes: res?.start_time?.split(':')[1]
                })

                setCloseTime({
                    hours: res?.end_time?.split(':')[0],
                    minutes: res?.end_time?.split(':')[1]
                })

                setPharmacyLogo(res?.logo)
                setEditableLocation(res?.location || '')
                setEditableOwnerName(res?.name || '')
                setEditablePhoneNumber(res?.mobile_no || '')
                setEditableEmail(res?.email || '')
                setLatitude(res?.latitude)
                setLongitude(res?.longitude)
                setPlaceId(res?.place_id)
                setAddressComponent(res?.address_component)
            })
            .catch(err => {
                setErrMsg(err)
            })
    }

    const handleLocationInputClick = () => {
        if (isEditActive) {
            setShowMap(true)
        }
    }

    const handleLocationSave = (selected, selectedString, placeId, addressComponent) => {
        setEditableLocation(selectedString)
        setLatitude(selected?.lat)
        setLongitude(selected?.lng)
        setPlaceId(placeId)
        setAddressComponent(addressComponent)
        setShowMap(false)
        setIsEditing(true)
    }

    const handleLocationCancel = () => {
        setShowMap(false)
    }

    // OTP handlers for phone number change
    const handlePhoneNumberChange = () => {
        if (editablePhoneNumber === data?.mobile_no) {
            setErrMsg('Please enter a different phone number')
            return
        }
        if (!editablePhoneNumber || editablePhoneNumber.length < 10) {
            setErrMsg('Please enter a valid phone number')
            return
        }
        setNewPhoneNumber(editablePhoneNumber)
        setShowOtpModal(true)
        setOtpStage(OTP_STAGE.SEND_OTP)
        setOtp(['', '', '', ''])
        setOtpError('')
    }

    const handleSendOtp = () => {
        setOtpError('')
        // Send OTP to the new phone number using authenticated API
        sendOTPHelper({ new_mobile_no: newPhoneNumber })
            .then(() => {
                setOtpStage(OTP_STAGE.VERIFY_OTP)
            })
            .catch(err => {
                setOtpError(err || 'Failed to send OTP')
            })
    }

    const handleVerifyOtp = () => {
        const otpValue = otp.join('')
        if (otpValue.length !== 4) {
            setOtpError('Please enter a valid 4-digit OTP')
            return
        }
        setOtpError('')
        // Verify OTP using authenticated API
        validateOTPHelper(otpValue)
            .then(() => {
                // OTP verified, now update the phone number
                updatePhoneNumberAfterOtpVerification()
            })
            .catch(err => {
                setOtpError(err || 'Invalid OTP')
            })
    }

    const updatePhoneNumberAfterOtpVerification = () => {
        let reqData = new FormData()
        reqData.append('mobile_no', newPhoneNumber)

        updatePersonalDetailsHelper(reqData)
            .then(() => {
                getPersonalDetails()
                setShowOtpModal(false)
                setOtpStage(OTP_STAGE.SEND_OTP)
                setOtp(['', '', '', ''])
                setOtpError('')
                setErrMsg(undefined)
            })
            .catch(err => {
                setOtpError(err || 'Failed to update phone number')
            })
    }

    const handleOtpChange = (index, value) => {
        if (value.length > 1) return
        const updatedOtp = [...otp]
        updatedOtp[index] = value.replace(/\D/g, '')
        setOtp(updatedOtp)

        if (value && index < 3) {
            otpInputs.current[index + 1]?.focus()
        }
    }

    const handleOtpKeyDown = (index, event) => {
        if (event.keyCode === 8 && !otp[index] && index > 0) {
            otpInputs.current[index - 1]?.focus()
        }
    }

    const handleResendOtp = () => {
        handleSendOtp()
    }

    const handleCloseOtpModal = () => {
        setShowOtpModal(false)
        setOtpStage(OTP_STAGE.SEND_OTP)
        setOtp(['', '', '', ''])
        setOtpError('')
        setEditablePhoneNumber(data?.mobile_no || '')
    }

    const updatePersonalDetails = () => {
        let reqData = new FormData()
        let hasChanges = false

        if (profileImageFile) {
            reqData.append('profile_image', profileImageFile)
            hasChanges = true
        }
        if (pharmacyLogo && typeof pharmacyLogo !== 'string') {
            reqData.append('logo', pharmacyLogo)
            hasChanges = true
        }
        if (startTime && (startTime.hours || startTime.minutes)) {
            reqData.append(
                'start_time',
                `${startTime?.hours}:${startTime?.minutes}`
            )
            hasChanges = true
        }
        if (closeTime && (closeTime.hours || closeTime.minutes)) {
            reqData.append(
                'end_time',
                `${closeTime.hours}:${closeTime.minutes}`
            )
            hasChanges = true
        }
        if (editableLocation && editableLocation !== data?.location) {
            reqData.append('location', editableLocation)
            hasChanges = true
            if (latitude) reqData.append('latitude', latitude)
            if (longitude) reqData.append('longitude', longitude)
            if (placeId) reqData.append('place_id', placeId)
            if (addressComponent) reqData.append('address_component', JSON.stringify(addressComponent))
        }

        if (!hasChanges) {
            return
        }

        updatePersonalDetailsHelper(reqData)
            .then(res => {
                getPersonalDetails()
                setErrMsg(undefined)
                setProfileImageFile(undefined)
                setIsEditActive(false)
                setIsEditing(false)
            })
            .catch(err => {
                setErrMsg(err)
            })
    }

    const updateOwnerDetails = () => {
        let reqData = new FormData()
        let hasChanges = false

        if (editableOwnerName && editableOwnerName !== data?.name) {
            reqData.append('name', editableOwnerName)
            hasChanges = true
        }
        // Phone number change now requires OTP verification - handled separately
        if (editableEmail && editableEmail !== data?.email) {
            reqData.append('email', editableEmail)
            hasChanges = true
        }

        if (!hasChanges) {
            setIsOwnerDetailsEditActive(false)
            return
        }

        updatePersonalDetailsHelper(reqData)
            .then(res => {
                getPersonalDetails()
                setErrMsg(undefined)
                setIsOwnerDetailsEditActive(false)
            })
            .catch(err => {
                setErrMsg(err)
            })
    }

    const handlePasswordUpdate = () => {
        if (newPassword !== confirmPassword) {
            setErrMsg('New Password and Confirm Password do not match')
            return
        }

        if (!currentPassword || !newPassword || !confirmPassword) {
            setErrMsg('Please enter all fields')
            return
        }

        if (currentPassword && newPassword && confirmPassword) {
            updatePasswordHelper(currentPassword, newPassword)
                .then(res => {
                    setCurrentPassword('')
                    setNewPassword('')
                    setConfirmPassword('')
                    setEditingPassword(false)
                    setErrMsg(undefined)
                })
                .catch(err => {
                    setErrMsg(err)
                })
        }
    }

    return (
        <>
            {isMobile && <MobileHeader headerOptions={headerOptions} />}
            <div className="pageBodyRightPanel">
                <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter">
                    <div className="pageBodyRightPanelHeading">
                        Personal Details
                    </div>
                </div>
                <div className="personalDetailsRow dFlex flexNowrap aiCenter">
                    <div className="personalIcon dFlex aiCenter jcContentCenter">
                        {data?.profile_image_url ? (
                            <img
                                className="iconImage"
                                src={Config.getFullImageUrl(
                                    data?.profile_image_url
                                )}
                                alt="Profile"
                            />
                        ) : (
                            convertToTitleCase(data?.branch_name?.[0])
                        )}
                    </div>
                    <div className="personalNameWrap">
                        <div className="personalName">{data?.branch_name}</div>
                        <div className="personalDesc">{data?.location}</div>
                    </div>
                </div>

                <div className="otherDetailsRow">
                    <div className="otherDetailsWrap">
                        <div className="otherDetailsHeading dFlex jcSpaceBetween aiCenter">
                            Pharmacy Store Details
                            <div
                                className="otherDetailsEdit"
                                onClick={() => {
                                    setErrMsg(undefined)
                                    setProfileImageFile(undefined)
                                    setIsEditActive(!isEditActive)
                                }}>
                                {isEditing && (
                                    <button
                                        className="btn btnPrimary block space"
                                        onClick={updatePersonalDetails}>
                                        {'SUBMIT'}
                                    </button>
                                )}

                                {isEditActive ? (
                                    <EditIconActive />
                                ) : (
                                    <EditIcon />
                                )}
                            </div>
                        </div>
                        {isEditActive && (
                            <div className="formGroup typeFile">
                                {!profileImageFile && (
                                    <div className="beforeUpload">
                                        <div className="inputHeading">
                                            {'Profile Image'}
                                        </div>
                                        <div className="customFile">
                                            <input
                                                type="file"
                                                className="fileInput"
                                                id={'Profile Image'}
                                                aria-describedby={
                                                    'Profile Image'
                                                }
                                                accept="image/*"
                                                onChange={e => {
                                                    setErrMsg(undefined)
                                                    if (
                                                        e.target.files[0]?.size >
                                                        2097152
                                                    ) {
                                                        setErrMsg(
                                                            'File size should not exceed 2MB'
                                                        )
                                                        return
                                                    }
                                                    setIsEditing(true)
                                                    setProfileImageFile(
                                                        e.target.files[0]
                                                    )
                                                }}
                                            />
                                            <label
                                                className="fileLabel"
                                                htmlFor={'Profile Image'}>
                                                <AttachIcon />
                                            </label>
                                        </div>
                                    </div>
                                )}
                                {profileImageFile && (
                                    <div className="uploadFile dFlex flexNowrap jcSpaceBetween">
                                        <div className="">
                                            <div className="inputHeading">
                                                {'Profile Image'}
                                            </div>
                                            <div className="uploadFileName">
                                                <a
                                                    id="myLink"
                                                    href={profileImageFile?.url}
                                                    target="_blank">
                                                    {profileImageFile?.name}
                                                </a>
                                            </div>
                                            <div className="uploadFileProgress">
                                                <div className="progress progress-moved">
                                                    <div
                                                        className={
                                                            profileImageFile
                                                                ? 'animation progress-bar'
                                                                : 'progress-bar'
                                                        }></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="cancelUpload"
                                            onClick={() => {
                                                // setErr('')
                                            }}>
                                            <div className="cancelUpload">
                                                <CheckIcon />{' '}
                                            </div>
                                            <div
                                                onClick={() => {
                                                    setIsEditing(false)
                                                    setProfileImageFile(
                                                        undefined
                                                    )
                                                }}>
                                                <CloseIcon />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        <div className="otherDetail">
                            <div className="otherDetailLabel">Location</div>
                            {!isEditActive ? (
                                <div className="otherDetailData">
                                    {data?.location}
                                </div>
                            ) : (
                                <div className="formGroup formFloating fgrow1 relative">
                                    <input
                                        type="text"
                                        className="formControl"
                                        id="location"
                                        placeholder="Location"
                                        value={editableLocation}
                                        autoComplete="off"
                                        onClick={handleLocationInputClick}
                                        readOnly
                                        required
                                    />
                                    <label htmlFor="location">Location</label>
                                    <div
                                        className="positionedIcon"
                                        onClick={handleLocationInputClick}
                                    >
                                        <LocationIcon />
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="otherDetail">
                            <div className="otherDetailLabel">Category</div>
                            <div className="otherDetailData">
                                {data?.pharmacy_category}
                            </div>
                        </div>
                        <div className="otherDetail storeTime">
                            <div
                                className="start"
                                onClick={() => setTimePopup('start')}>
                                <div className="otherDetailLabel">
                                    Start Time
                                </div>
                                <div className="otherDetailData">
                                    {startTime.hours || startTime.minutes
                                        ? `${startTime.hours}:${startTime.minutes}`
                                        : data?.start_time || '00:00'}
                                </div>
                            </div>
                            <div
                                className="close"
                                onClick={() => setTimePopup('close')}>
                                <div className="otherDetailLabel">
                                    Close Time
                                </div>
                                <div className="otherDetailData">
                                    {closeTime.hours || closeTime.minutes
                                        ? `${closeTime.hours}:${closeTime.minutes}`
                                        : data?.end_time || '00:00'}
                                </div>
                            </div>
                            {timePopup && (
                                <div className="timePopup">
                                    <div className="timePopupInner">
                                        <div className="timePopupHeader">
                                            {timePopup === 'start'
                                                ? 'Start Time'
                                                : 'Close Time'}
                                        </div>
                                        <div className="timePopupBody">
                                            <div className="timePopupTime">
                                                <input
                                                    type="text"
                                                    value={
                                                        timePopup === 'start'
                                                            ? startTime.hours
                                                            : closeTime.hours
                                                    }
                                                    max={23}
                                                    onChange={e => {
                                                        setIsEditing(true)
                                                        timePopup === 'start'
                                                            ? setStartTime({
                                                                ...startTime,
                                                                hours: e
                                                                    .target
                                                                    .value
                                                            })
                                                            : setCloseTime({
                                                                ...closeTime,
                                                                hours: e
                                                                    .target
                                                                    .value
                                                            })
                                                    }}
                                                />
                                                <p className="timePopupTimeSubtitle">
                                                    Hours
                                                </p>
                                            </div>
                                            <div className="timePopupColon">
                                                <p>:</p>
                                            </div>
                                            <div className="timePopupTime">
                                                <input
                                                    type="text"
                                                    value={
                                                        timePopup === 'start'
                                                            ? startTime.minutes
                                                            : closeTime.minutes
                                                    }
                                                    max={59}
                                                    onChange={e => {
                                                        setIsEditing(true)
                                                        timePopup === 'start'
                                                            ? setStartTime({
                                                                ...startTime,
                                                                minutes:
                                                                    e.target
                                                                        .value
                                                            })
                                                            : setCloseTime({
                                                                ...closeTime,
                                                                minutes:
                                                                    e.target
                                                                        .value
                                                            })
                                                    }}
                                                />
                                                <p className="timePopupTimeSubtitle">
                                                    Minutes
                                                </p>
                                            </div>
                                        </div>
                                        <div className="timePopupFooter">
                                            <button
                                                className="btn btnPrimaryOutlined"
                                                onClick={() => {
                                                    setIsEditing(false)
                                                    setTimePopup('')
                                                }}>
                                                Cancel
                                            </button>
                                            <button
                                                className="btn btnPrimary"
                                                onClick={() => {
                                                    updatePersonalDetails()
                                                    setTimePopup('')
                                                }}>
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="otherDetail">
                            <div className="otherDetailLabel">
                                Pharmacy Logo
                            </div>
                            <div className="otherDetailData profileLogo">
                                <div
                                    className="profileLogoInner"
                                    style={{ display: 'flex', gap: '15px' }}>
                                    {pharmacyLogo && (
                                        <div
                                            className="logoPreview"
                                            style={{
                                                border: '1px solid #ddd',
                                                borderRadius: '8px',
                                                padding: '10px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                minWidth: '120px',
                                                maxWidth: '150px',
                                                background: '#f9f9f9'
                                            }}>
                                            <img
                                                src={
                                                    typeof pharmacyLogo ===
                                                    'string'
                                                        ? Config.getFullImageUrl(
                                                              pharmacyLogo
                                                          )
                                                        : URL.createObjectURL(
                                                              pharmacyLogo
                                                          )
                                                }
                                                alt="Pharmacy Logo"
                                                style={{
                                                    maxWidth: '100%',
                                                    maxHeight: '80px',
                                                    objectFit: 'contain'
                                                }}
                                            />
                                        </div>
                                    )}
                                    <div style={{ flex: 1 }}>
                                        {!pharmacyLogo ? (
                                            <>
                                                {isEditActive && (
                                                    <>
                                                        <input
                                                            type="file"
                                                            hidden
                                                            id="pharmacyLogo"
                                                            name="pharmacyLogo"
                                                            accept="image/*"
                                                            onChange={e => {
                                                                setErrMsg(
                                                                    undefined
                                                                )
                                                                if (
                                                                    e.target
                                                                        .files[0]
                                                                        ?.size >
                                                                    2097152
                                                                ) {
                                                                    setErrMsg(
                                                                        'File size should not exceed 2MB'
                                                                    )
                                                                    return
                                                                }
                                                                setIsEditing(
                                                                    true
                                                                )
                                                                setPharmacyLogo(
                                                                    e.target
                                                                        .files[0]
                                                                )
                                                            }}
                                                        />
                                                        <label htmlFor="pharmacyLogo">
                                                            Upload Pharmacy Logo
                                                        </label>
                                                    </>
                                                )}
                                                {!isEditActive && (
                                                    <div>No Logo Uploaded</div>
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                {isEditActive && (
                                                    <div className="profileLogoInnerName">
                                                        {pharmacyLogo?.name ||
                                                            'Logo Uploaded'}
                                                        <span
                                                            onClick={() => {
                                                                setErrMsg(
                                                                    undefined
                                                                )
                                                                setIsEditing(
                                                                    true
                                                                )
                                                                setPharmacyLogo(
                                                                    undefined
                                                                )
                                                            }}>
                                                            <CloseIcon />
                                                        </span>
                                                    </div>
                                                )}
                                                {isEditing &&
                                                    pharmacyLogo?.name && (
                                                        <div className="uploadFileProgress">
                                                            <div className="progress progress-moved">
                                                                <div
                                                                    className={
                                                                        pharmacyLogo
                                                                            ? 'animation progress-bar'
                                                                            : 'progress-bar'
                                                                    }></div>
                                                            </div>
                                                        </div>
                                                    )}
                                            </>
                                        )}
                                    </div>
                                </div>
                                {isEditActive && (
                                    <label
                                        htmlFor="pharmacyLogo"
                                        className="profileLogoIcon">
                                        <AttachIcon />
                                    </label>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="otherDetailsWrap">
                        <div className="otherDetailsHeading dFlex jcSpaceBetween aiCenter">
                            Owner Details
                            <div
                                className="otherDetailsEdit"
                                onClick={() => {
                                    setErrMsg(undefined)
                                    setIsOwnerDetailsEditActive(
                                        !isOwnerDetailsEditActive
                                    )
                                }}>
                                {isOwnerDetailsEditActive && (
                                    <button
                                        className="btn btnPrimary block space"
                                        onClick={updateOwnerDetails}>
                                        {'SUBMIT'}
                                    </button>
                                )}
                                {isOwnerDetailsEditActive ? (
                                    <EditIconActive />
                                ) : (
                                    <EditIcon />
                                )}
                            </div>
                        </div>
                        <div className="otherDetail">
                            <div className="otherDetailLabel">Name</div>
                            {!isOwnerDetailsEditActive ? (
                                <div className="otherDetailData">
                                    {data?.name}
                                </div>
                            ) : (
                                <div className="formGroup formFloating fgrow1">
                                    <input
                                        type="text"
                                        className="formControl"
                                        id="ownerName"
                                        placeholder="Name"
                                        value={editableOwnerName}
                                        onChange={e => {
                                            setEditableOwnerName(e.target.value)
                                        }}
                                        required
                                    />
                                    <label htmlFor="ownerName">Name</label>
                                </div>
                            )}
                        </div>
                        <div className="otherDetail">
                            <div className="otherDetailLabel">Phone Number</div>
                            {!isOwnerDetailsEditActive ? (
                                <div className="otherDetailData">
                                    {data?.mobile_no}
                                </div>
                            ) : (
                                <div className="phoneNumberEditWrapper dFlex aiCenter">
                                    <div className="formGroup formFloating fgrow1 mb-0">
                                        <input
                                            type="text"
                                            className="formControl"
                                            id="phoneNumber"
                                            placeholder="Phone Number"
                                            value={editablePhoneNumber}
                                            onChange={e => {
                                                const numericInput = e.target.value.replace(/\D/g, '')
                                                setEditablePhoneNumber(numericInput)
                                            }}
                                            maxLength={11}
                                            required
                                        />
                                        <label htmlFor="phoneNumber">
                                            Phone Number
                                        </label>
                                    </div>
                                    {editablePhoneNumber !== data?.mobile_no && (
                                        <button
                                            className="btn btnPrimary ml-3"
                                            onClick={handlePhoneNumberChange}
                                        >
                                            Verify
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="otherDetail">
                            <div className="otherDetailLabel">Email ID</div>
                            {!isOwnerDetailsEditActive ? (
                                <div className="otherDetailData">
                                    {data?.email}
                                </div>
                            ) : (
                                <div className="formGroup formFloating fgrow1">
                                    <input
                                        type="email"
                                        className="formControl"
                                        id="email"
                                        placeholder="Email ID"
                                        value={editableEmail}
                                        onChange={e => {
                                            setEditableEmail(e.target.value)
                                        }}
                                        required
                                    />
                                    <label htmlFor="email">Email ID</label>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="otherDetailsWrap">
                        <div className="otherDetailsHeading dFlex jcSpaceBetween aiCenter">
                            Password
                            <span
                                onClick={() =>
                                    setEditingPassword(!editingPassword)
                                }>
                                {editingPassword ? <CloseIcon /> : <EditIcon />}
                            </span>
                        </div>
                        {!editingPassword && (
                            <div className="otherDetail">
                                <div className="otherDetailLabel">
                                    Current Password
                                </div>
                                <div className="otherDetailData">°°°°°°°°°</div>
                            </div>
                        )}

                        {editingPassword && (
                            <>
                                <div className="formGroup">
                                    <div className="formGroup formFloating fgrow1">
                                        <input
                                            type="password"
                                            className="formControl"
                                            value={currentPassword}
                                            onChange={e => {
                                                setCurrentPassword(
                                                    e.target.value
                                                )
                                            }}
                                            id="current_password"
                                            placeholder="Current Password"
                                        />
                                        <label htmlFor="current_password">
                                            Current Password
                                        </label>
                                    </div>

                                    <div className="formSection dFlex">
                                        <div className="formGroup formFloating fgrow1">
                                            <input
                                                type="password"
                                                className="formControl"
                                                id="password"
                                                value={newPassword}
                                                placeholder="New Password"
                                                onChange={e => {
                                                    setNewPassword(
                                                        e.target.value
                                                    )
                                                }}
                                            />
                                            <label htmlFor="password">
                                                New Password
                                            </label>
                                        </div>

                                        <div className="formGroup formFloating fgrow1 ml-5">
                                            <input
                                                type="password"
                                                className="formControl"
                                                id="confirm_password"
                                                placeholder="Confirm New Password"
                                                onChange={e => {
                                                    setConfirmPassword(
                                                        e.target.value
                                                    )
                                                }}
                                            />
                                            {newPassword.length > 0 &&
                                                confirmPassword.length > 0 &&
                                                confirmPassword ===
                                                newPassword && (
                                                    <span className="passwordMatch">
                                                        <CheckIcon />
                                                    </span>
                                                )}
                                            <label htmlFor="confirm_password">
                                                Confirm New Password
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                {editingPassword && (
                                    <button
                                        className="btn btnPrimary block "
                                        disabled={
                                            !currentPassword ||
                                            !newPassword ||
                                            !confirmPassword ||
                                            confirmPassword !== newPassword
                                        }
                                        onClick={handlePasswordUpdate}>
                                        Update Password
                                    </button>
                                )}
                            </>
                        )}
                    </div>
                </div>
                {errMsg && <div className="invalidFeedback">{errMsg}</div>}
            </div>
            {showMap && (
                <div className="locationContainer">
                    <div className="welcomeHeading">
                        <span>LOCATION</span>
                    </div>
                    <CustomMap
                        onClose={handleLocationCancel}
                        onSave={handleLocationSave}
                    />
                </div>
            )}
            {showOtpModal && (
                <div className="otpModalOverlay">
                    <div className="otpModal">
                        <div className="otpModalHeader dFlex jcSpaceBetween aiCenter">
                            <span className="otpModalTitle">
                                {otpStage === OTP_STAGE.SEND_OTP
                                    ? 'Verify Phone Number'
                                    : 'Enter OTP'}
                            </span>
                            <span
                                className="otpModalClose"
                                onClick={handleCloseOtpModal}
                            >
                                <CloseIcon />
                            </span>
                        </div>
                        <div className="otpModalBody">
                            {otpStage === OTP_STAGE.SEND_OTP && (
                                <>
                                    <p className="otpModalDesc">
                                        An OTP will be sent to your new phone number:
                                    </p>
                                    <p className="otpModalPhone">{newPhoneNumber}</p>
                                </>
                            )}
                            {otpStage === OTP_STAGE.VERIFY_OTP && (
                                <>
                                    <p className="otpModalDesc">
                                        Enter the 4-digit OTP sent to:
                                    </p>
                                    <p className="otpModalPhone">{newPhoneNumber}</p>
                                    <div className="otpInputWrapper dFlex jcContentCenter">
                                        {[0, 1, 2, 3].map(index => (
                                            <input
                                                key={index}
                                                type="text"
                                                className="otpInput"
                                                maxLength={1}
                                                value={otp[index]}
                                                onChange={e =>
                                                    handleOtpChange(index, e.target.value)
                                                }
                                                onKeyDown={e =>
                                                    handleOtpKeyDown(index, e)
                                                }
                                                ref={el =>
                                                    (otpInputs.current[index] = el)
                                                }
                                            />
                                        ))}
                                    </div>
                                    <p className="otpInfo textCenter">
                                        OTP is valid for 2 mins
                                    </p>
                                    <p
                                        className="otpResend textCenter"
                                        onClick={handleResendOtp}
                                    >
                                        RESEND OTP
                                    </p>
                                </>
                            )}
                            {otpError && (
                                <div className="invalidFeedback textCenter">
                                    {otpError}
                                </div>
                            )}
                        </div>
                        <div className="otpModalFooter dFlex jcSpaceBetween">
                            <button
                                className="btn btnPrimaryOutlined"
                                onClick={handleCloseOtpModal}
                            >
                                Cancel
                            </button>
                            {otpStage === OTP_STAGE.SEND_OTP && (
                                <button
                                    className="btn btnPrimary"
                                    onClick={handleSendOtp}
                                >
                                    Send OTP
                                </button>
                            )}
                            {otpStage === OTP_STAGE.VERIFY_OTP && (
                                <button
                                    className="btn btnPrimary"
                                    onClick={handleVerifyOtp}
                                    disabled={otp.join('').length !== 4}
                                >
                                    Verify
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

const mapStateToProps = state => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(PersonalDetails)
